import React from 'react';
import { ParcelSearchContextProvider } from 'src/components/Views/ParcelSearchV1/HomeView/ParcelSearchContext';
import MainLayoutInner from '../MainLayoutInner/MainLayoutInner';
import { Permissions } from '@lanterds/types';
import { isAuthorized } from 'src/util/Permissions';
import { getUserEmailFromToken } from 'src/util/helpers';
import PermissionsError from 'src/components/common/PermissionsError/PermissionsError';

export default function ParcelSearchLayout() {
    const userEmail = getUserEmailFromToken();

    const isParcelSearchAuthorized = isAuthorized(userEmail, Permissions.parcelSearch);

    return (
        <>
            {isParcelSearchAuthorized ? (
                <ParcelSearchContextProvider>
                    <MainLayoutInner />
                </ParcelSearchContextProvider>
            ) : (
                <PermissionsError />
            )}
        </>
    );
}
